import React, { useEffect, useState } from 'react'

import { AppConfig } from '../config/appConfig';
import { Alert, Button } from '@mui/material';
import { Buffer } from 'buffer';
import { IGeneratedDocument } from '../types/document';

import "../styles/generatedDocumentViewer.scss";

export interface IGeneratedDocumentViewerProps {
	generatedDocument: IGeneratedDocument | undefined,
}

const GeneratedDocumentViewer: React.FunctionComponent<IGeneratedDocumentViewerProps> = ({ generatedDocument }) => {

	//For viewing document data directly instead of fetching from API
	const [previewUrl, setPreviewUrl] = useState("");
	const [downloadUrl, setDownloadUrl] = useState("");
	const [fileName, setFileName] = useState("");

	useEffect(() => {
		if (generatedDocument) {
			loadGeneratedDocument();
		}
	}, [generatedDocument])

	const loadGeneratedDocument = async () => {
		if (generatedDocument && generatedDocument.contents) {
			if (generatedDocument.name) setFileName(generatedDocument.name);
			const blob = new Blob([Buffer.from(generatedDocument.contents, "base64")], {
				type: generatedDocument.contentType
			});
			const blobUrl = URL.createObjectURL(blob);
			setDownloadUrl(blobUrl);

			if (AppConfig.viewableDocumentTypes.filter((item) => { return item == generatedDocument.contentType?.toLowerCase() ? true : false; }).length > 0) {
				setPreviewUrl(blobUrl);
			}
			else {
				setPreviewUrl(undefined);
			}
		}
	}
	return generatedDocument ? (
		<div className="hwi-document-viewer">
			<section className="search-bar">
				<div className="search-header">
					<div className="title">
						<a id="viewertop">{fileName ?? "Combined Document"}</a>
					</div>
					<div className="controls">
						<a href={downloadUrl} target="_blank"><Button variant='outlined'>Open In New Tab</Button></a>
						<a href={downloadUrl} download={fileName}><Button variant='outlined'>Download</Button></a>
					</div>
				</div>
			</section>
			<div className="document-wrapper">
				<Alert className="alert" severity="info" >
					Depending on the document type and your browser settings you may not be able to preview documents in the application. If your document does not load below, please use the Download button to download a local copy.
				</Alert>
				{previewUrl &&
					<iframe onLoad={() => window.scrollTo({ top: document.getElementById("viewertop").offsetTop - 20, behavior: 'smooth' })} className="document-frame" src={previewUrl}></iframe>
				}
			</div>
		</div>
	) : null;
}

export default GeneratedDocumentViewer;